import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { obscureTaxID } from '@woovi/utils';

type TaxID = {
  taxID: string;
  type: string;
};

type PaymentMethodCreditCardCustomerDataProps = {
  customer?: {
    name?: string;
    email?: string;
    taxID?: TaxID;
    phone?: string;
  };
};

const PaymentMethodCreditCardCustomerData = ({
  customer,
}: PaymentMethodCreditCardCustomerDataProps): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const renderInfoRow = (label: string, value?: string) => (
    <Stack spacing={0.5} sx={{ flex: 1 }} direction='row'>
      <Typography
        sx={{
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.grey[600],
        }}
      >
        {label}:
      </Typography>
      <Typography>{value ?? '-'}</Typography>
    </Stack>
  );

  if (!customer) {
    return null;
  }

  return (
    <Stack
      spacing={2}
      sx={{
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.shape.borderRadius,
        p: 2,
      }}
    >
      <Stack direction={{ xs: 'column', sm: 'row' }}>
        {renderInfoRow(t('Payer'), customer?.name)}
        {renderInfoRow(
          'CPF/CNPJ',
          customer?.taxID?.taxID ? obscureTaxID(customer.taxID.taxID) : '-',
        )}
      </Stack>
      <Stack direction={{ xs: 'column', sm: 'row' }}>
        {renderInfoRow('E-mail', customer?.email)}
        {renderInfoRow(t('Phone'), customer?.phone)}
      </Stack>
    </Stack>
  );
};

export default PaymentMethodCreditCardCustomerData;
